import UserService from '../../services/UserService.js'

export const namespaced = true

export const state = {
  user: {},
  token: '',
  refreshToken: ''
}

export const mutations = {
  SET_USER(state, user) {
    if (user) {
      window.localStorage.setItem('user', JSON.stringify(user))
      state.user = user
    }
    else {
      window.localStorage.removeItem('user')
      state.user = {}
    }    
  },
  SET_TOKEN(state, token) {
    if (token) window.localStorage.setItem('token', token)
    else window.localStorage.removeItem('token')

    state.token = token
  },
  SET_REFRESH_TOKEN(state, refreshToken) {
    if (refreshToken) window.localStorage.setItem('refreshToken', refreshToken)
    else window.localStorage.removeItem('refreshToken')

    state.refreshToken = refreshToken
  }
}

export const actions = {
  setUser({ commit }, user) {
    return new Promise(resolve => {
      commit('SET_USER', user)
      resolve()
    })
  },
  setToken({ commit }, token) {
    return new Promise(resolve => {
      commit('SET_TOKEN', token)
      resolve()
    })
  },
  setRefreshToken({ commit }, refreshToken) {
    return new Promise(resolve => {
      commit('SET_REFRESH_TOKEN', refreshToken)
      resolve()
    })
  },
  setTokens({ commit }, tokens) {
    return new Promise(resolve => {
      commit('SET_TOKEN', tokens.token)
      commit('SET_REFRESH_TOKEN', tokens.refreshToken)
      resolve()
    })
  },
  setUserData({ commit }, data) {
    return new Promise(resolve => {
      commit('SET_USER', { email: data.email, name: data.name, role: data.role })
      commit('SET_TOKEN', data.token)
      commit('SET_REFRESH_TOKEN', data.refreshToken)
      resolve()
    })
  },
  logout({ commit }) {
    return new Promise(resolve => {
      commit('SET_USER', '')
      commit('SET_REFRESH_TOKEN', '')
      return Promise.all([this.dispatch('submission/clear'), this.dispatch('change/clear'), this.dispatch('entity/clear'), this.dispatch('document/clear'), this.dispatch('officer/clear')]).then(() => {
        resolve()
      })
    })
  },
  getInfo() {
    return UserService.getInfo()
  }
}

export const getters = {
  name: state => state.user ? state.user.name : '',
  loggedIn: state => !!state.user,
  isDCOUser: state => state.user.role == 'dco'
}